export interface CategoriasWebMenu {
    articulos: number,
    categoria: number
    imagen: string,
    nombre: string,
    orden: number,
    padre: number,
    marca?: number,
    codigo?: number,
    subCategorias?: CategoriasWebMenu[],
    desplegado?: boolean,
}